import React, { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import Root from './root';
import ErrorPage from './error-page';

const lazyload = loader => React.createElement(lazy(loader));

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to='/m' replace={ true } />
  },
  {
    path: '/m',
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: lazyload(() => import('../pages/index'))
      },
      {
        path: 'view',
        element: lazyload(() => import('../pages/view'))
      },
      {
        path: 'my',
        element: lazyload(() => import('../pages/my'))
      },
      {
        path: 'play',
        element: lazyload(() => import('../pages/play'))
      },
      {
        path: 'play-end',
        element: lazyload(() => import('../pages/play-end'))
      },
      {
        path: 'vip',
        element: lazyload(() => import('../pages/vip'))
      },
      // {
      //   path: 'pay',
      //   element: lazyload(() => import('../pages/pay'))
      // },
      {
        path: 'pay-middle',
        element: lazyload(() => import('../pages/pay-middle'))
      },
      {
        path: 'task',
        element: lazyload(() => import('../pages/task'))
      },
      {
        path: 'my-consume',
        element: lazyload(() => import('../pages/my-consume'))
      },
      {
        path: 'my-welth-coupon',
        element: lazyload(() => import('../pages/my-welth-coupon'))
      },
      {
        path: 'my-collect',
        element: lazyload(() => import('../pages/my-collect'))
      },
      {
        path: 'my-like',
        element: lazyload(() => import('../pages/my-like'))
      },
      {
        path: 'my-history',
        element: lazyload(() => import('../pages/my-history'))
      },
      {
        path: 'contact',
        element: lazyload(() => import('../pages/contact'))
      },
      {
        path: 'privacy-policy',
        element: lazyload(() => import('../pages/privacy-policy'))
      },
      {
        path: 'refund-policy',
        element: lazyload(() => import('../pages/refund-policy'))
      },
      {
        path: 'debug',
        element: lazyload(() => import('../pages/debug'))
      },
      {
        path: 'empty',
        element: lazyload(() => import('../pages/empty'))
      }
    ]
  },
  {
    path: '*',
    element: <Navigate to='/m/empty' replace={ true } />
  }
]);

export default router;
